import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Attractiveness from "./pages/attractiveness";
import Landing from "./pages/landing";
import FitFinder from "./pages/fit-finder";
import Crm from "./pages/crm";
import UserDetailsPage from "./pages/crm/userPage";
import GridPage from "./pages/attractiveness/GridPage";
import FindMatches from "./pages/attractiveness/findMatches";
import Introductions from "./pages/introductions";
import Sms from "./pages/sms";
import AppBar from "./components/AppBar";
import Sidebar from "./components/Sidebar";

function App() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <div className="bg-gray-50">
      <AppBar />
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        onToggle={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />
      <div
        className={`transition-all duration-300 ${
          isSidebarCollapsed ? "ml-16" : "ml-64"
        }`}
      >
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/attractiveness" element={<Attractiveness />} />
          <Route path="/fit-finder" element={<FitFinder />} />
          <Route path="/grid" element={<GridPage />} />
          <Route path="/crm" element={<Crm />} />
          <Route path="/crm/:id" element={<UserDetailsPage />} />
          <Route path="/matches/:id" element={<FindMatches />} />
          <Route path="/introductions" element={<Introductions />} />
          <Route path="/sms" element={<Sms />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
